// Montants et mesures d'un envoi. Chaque colis porte son propre prix et son
// propre état de paiement ; le total n'est qu'une somme.
// Fonctions pures : aucune dépendance React ni réseau.

const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

const round2 = (n) => Math.round(n * 100) / 100;

export function volumeCbm(item) {
  return (num(item?.length_cm) * num(item?.width_cm) * num(item?.height_cm)) / 1_000_000;
}

export function totalWeight(items = []) {
  return round2(items.reduce((sum, it) => sum + num(it?.weight), 0));
}

export function totalVolumeCbm(items = []) {
  return items.reduce((sum, it) => sum + volumeCbm(it), 0);
}

export function itemPrice(item) {
  return num(item?.price);
}

export function totalPrice(items = []) {
  return round2(items.reduce((sum, it) => sum + itemPrice(it), 0));
}

/** Ce qui est déjà encaissé sur un colis : tout s'il est réglé, l'avance sinon. */
export function amountPaid(item) {
  if (item?.payment_status === 'paid') return itemPrice(item);
  if (item?.payment_status === 'advance') return Math.min(num(item?.advance_amount), itemPrice(item));
  return 0;
}

export function totalPaid(items = []) {
  return round2(items.reduce((sum, it) => sum + amountPaid(it), 0));
}

export function totalDue(items = []) {
  return round2(Math.max(0, totalPrice(items) - totalPaid(items)));
}

/**
 * Prix proposé pour un colis : son poids au tarif de la route, plus le
 * supplément de catégorie éventuel. Le tarif maritime au volume n'existe pas
 * encore côté grille : seul le supplément est proposé dans ce mode.
 */
export function suggestedItemPrice({ item, transportMode = 'aerien', ratePerKg = 0, supplement = 0 }) {
  if (transportMode === 'maritime') return round2(num(supplement));
  return round2(num(item?.weight) * num(ratePerKg) + num(supplement));
}

/**
 * État de paiement d'un envoi, colis par colis. Sert au récapitulatif : combien
 * sont réglés, avancés, impayés, et par quels moyens.
 */
export function paymentSummary(items = []) {
  const counts = { paid: 0, advance: 0, unpaid: 0 };
  const methods = [];

  items.forEach((item) => {
    const status = item?.payment_status || 'unpaid';
    if (counts[status] === undefined) counts.unpaid += 1;
    else counts[status] += 1;
    if (item?.payment_method && !methods.includes(item.payment_method)) {
      methods.push(item.payment_method);
    }
  });

  return {
    ...counts,
    methods,
    hasAny: items.some((item) => item?.payment_status || item?.payment_method),
  };
}
